var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPictogramExclamationTriangle96 = function SvgPictogramExclamationTriangle96(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 77,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D2329",
    d: "M80 76.5H6a6 6 0 0 1-5.2-9l37-64.07a6 6 0 0 1 10.4 0L85.19 67.5a6 6 0 0 1-5.19 9M39.54 4.43l-37 64.07a4 4 0 0 0 3.46 6h74a4 4 0 0 0 3.47-6l-37-64.07a4 4 0 0 0-6.92 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009FDB",
    d: "M42 58.5h2v2h-2zm0-36v31h2v-31z"
  }))));
};
export default SvgPictogramExclamationTriangle96;